module.exports = __webpack_public_path__ + "img/home-h-a.c10fbe28.png";